import React from 'react';
import { styled } from '@mui/material';
import { useAppSelector } from '@/redux/hooks';
import { selectAvailPlatform } from '@/redux/selectors/constantsSelectors';

// TODO: should be a better way to import these
import amazon from '@/components/Focus/configs/assets/amazonprime.png';
import apple from '@/components/Focus/configs/assets/apple.png';
import clarovideo from '@/components/Focus/configs/assets/clarovideo.png';
import hulu from '@/components/Focus/configs/assets/hulu.png';
import oando from '@/components/Focus/configs/assets/oando.png';
import roku from '@/components/Focus/configs/assets/roku.png';
import sonyliv from '@/components/Focus/configs/assets/sonyliv.png';
import yangoplay from '@/components/Focus/configs/assets/yangoplay.png';
import youtube from '@/components/Focus/configs/assets/youtube.png';
import ConditionalTooltip from '@/components/_common/ConditionalTooltip/ConditionalTooltip';
import { FocusTheme } from '@/components/Focus/configs/theme';

interface Props {
  name: string;
  size?: 'small' | 'medium';
  disableTooltip?: boolean;
}

const PlatformIcon: React.FC<Props> = ({ name, size = 'medium', disableTooltip }) => {
  const allPlatforms = useAppSelector(selectAvailPlatform);
  const image = getPlatformImage(name);

  return (
    <ConditionalTooltip show={!disableTooltip} title={allPlatforms[name] ? allPlatforms[name] : name} placement="top">
      <PlatformIconStyled hasImage={Boolean(image)} size={size}>
        {image ? <StyledImg src={image} alt={name} /> : name[0].toUpperCase()}
      </PlatformIconStyled>
    </ConditionalTooltip>
  );
};

export default PlatformIcon;

export const sizesMap = { small: 24, medium: 32 };

export const PlatformIconStyled = styled('div')<{ hasImage: boolean; size?: 'small' | 'medium'; clickable?: boolean }>`
  ${({ theme, hasImage, size: _size = 'medium', clickable = false }) => {
    const size = sizesMap[_size];

    return `
      display: flex;
      align-items: center;
      justify-content: center;
      width: ${size}px;
      height: ${size}px;
      border-radius: 50%;
      border: ${hasImage || clickable ? '0' : `1px solid ${(theme as FocusTheme).palette.neutral[70]}`};
      font-size: 14px;
      background-color: ${clickable ? (theme as FocusTheme).palette.neutral[100] : (theme as FocusTheme).palette.neutral[50]};
      transition: background-color 0.2s;
      &:hover {
        background-color: ${(theme as FocusTheme).palette.neutral[50]};
      }
    `;
  }}
`;

const StyledImg = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const getPlatformImage = (name: string): string | null => {
  switch (name.toLowerCase()) {
    case 'amazonprime':
      return amazon;
    case 'apple':
      return apple;
    case 'clarovideo':
    case 'clarovideomexico':
    case 'clarovodbrazil':
      return clarovideo;
    case 'hulu':
      return hulu;
    case 'oando':
    case 'croando':
      return oando;
    case 'roku':
      return roku;
    case 'sonyliv':
      return sonyliv;
    case 'yangoplay':
      return yangoplay;
    case 'youtube':
      return youtube;
    default:
      return null;
  }
};
